import { P, makeFocusRing, pxToRem } from '@workramp/ui';
import styled from 'styled-components';

export const StyledWrapper = styled.div<{ hasError: boolean }>`
  border-radius: ${({ theme }) => theme.radii.xl}px;
  border: 1px solid;
  border-color: ${({ hasError, theme }) => (hasError ? theme.colors.danger[500] : theme.colors.on[100])};
  ${({ hasError, theme }) => hasError && makeFocusRing(theme.colors.danger[500])}
`;
export const StyledErrorMessage = styled(P)`
  font-size: ${({ theme }) => theme.typography.generateFontSize(0)}px;
  color: ${({ theme }) => theme.colors.danger[500]};
`;

export const StyledLabel = styled.label`
  display: block;
  margin-bottom: ${({ theme }) => theme.spacing(2)}px;
  color: ${({ theme }) => theme.colors.on[700]};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  font-size: ${({ theme }) => pxToRem(theme.typography.generateFontSize(1))}rem;
  line-height: 1rem;
`;
